<template>
    <div class='Box'>
        <el-dialog title="切换商务" :close-on-click-modal="false" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
            <el-form :model="addFrom" size="medium" label-width="100px" class="mt35"  ref="ruleForm">
                <el-row :gutter="35">
                    <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="15" class="mb20">
                        <el-form-item label="状态" prop="status">
                            <el-radio-group v-model="addFrom.status">
                                <el-radio :label="1">正常切换</el-radio>
                                <el-radio :label="0">离职继承</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <div v-if="addFrom.status==1">
                        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="11" class="mb20">
                            <el-form-item label="vipID" prop="username">
                                <el-input v-model="addFrom.username" placeholder="请输入用户名称" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="11" class="mb20">
                            <el-form-item label="商务" prop="nickname">
                                <el-input v-model="addFrom.username" placeholder="请输入昵称" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </div>
                    <div v-if="addFrom.status==0">
                        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="11" class="mb20">
                            <el-form-item label="离职商务" prop="password">
                                <el-input v-model="addFrom.username" placeholder="请输入离职商务" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="11" class="mb20">
                            <el-form-item label="继承商务">
                                <el-input v-model="addFrom.username" placeholder="请输入邮箱" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </div>


                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addnone">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: ['dialogVisible'],
    data() {
        return {
            addFrom:{
                status:1,
                username:""
            }
        };
    },
    methods: {
        handleClose(done) {
          this.$emit('busNone');
        },
        addnone() {
            this.$emit('busNone');
        }
    },
    created() {

    },
    mounted() {
    },
}
</script>
<style lang='scss' scoped>
.Box {
    & ::v-deep .el-dialog {
        .el-dialog__body {
            padding: 0 !important;
        }
    }
}
</style>
